import { Box } from '@palmetto/palmetto-components';
import { format } from 'date-fns';

import EventBy from './EventBy';

const PlacedInServiceCalculated = ({ event }: { event: any }) => {
  const placedInServiceDate = event?.data?.placedInServiceDate
    ? format(new Date(event.data.placedInServiceDate), 'MMM d, yyyy')
    : 'N/A';

  const triggerEvent = event?.data?.triggerEvent;

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} />
        <span> Placed In Service date calculated: </span>
        <strong>{placedInServiceDate}</strong>
        {triggerEvent && (
          <>
            <span> (triggered by </span>
            <strong>{triggerEvent}</strong>
            <span>)</span>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PlacedInServiceCalculated;
